const BASE_URL = "https://us-central1-pwa2apk.cloudfunctions.net/pwa2apk/api";
const BASE_URL_WEB2DESK = "https://us-central1-appmaker-desktop-new.cloudfunctions.net/web2desk/api";
const PWA2APK_PAYMENT_REDIRECT_URL =
  "https://us-central1-pwa2apk.cloudfunctions.net/pwa2apk/payment/process";
const WEB2DESK_PAYMENT_REDIRECT_URL =
  "https://us-central1-appmaker-desktop-new.cloudfunctions.net/web2desk/payment/process";
const createApp = formData => {
  /* eslint-disable */
  return fetch(`${BASE_URL}/step-1`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    return response.json();
  });
};
const updateApp = formData => {
  return fetch(`${BASE_URL}/step-2`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    return response.json();
  });
};
const checkStatus = formData => {
  return fetch(`${BASE_URL}/get-status`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    return response.json();
  });
};
const getApp = id => {
  return fetch(`${BASE_URL}/app/${id}`).then(function(response) {
    return response.json();
  });
};
const emailDeveloper = formData => {
  return fetch(`${BASE_URL}/email-developer`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  }).then(function(response) {
    return response.json();
  });
};
const uploadFile = formData => {
  const data = new FormData();
  data.append("file", formData.file);
  data.append("id", formData.id);
  return fetch(`${BASE_URL}/upload-icon`, {
    method: "POST",
    body: data
  }).then(function(response) {
    return response.json();
  });
};

const createDesktopApp = formData => {
  return fetch(`${BASE_URL_WEB2DESK}/create_app`, {
    method: "POST",
    body: formData
  }).then(function(response) {
    return response.json();
  });
};
const getDesktopAppStatus = ({ appId }) => {
  return fetch(`${BASE_URL_WEB2DESK}/check_status`, {
    method: "POST",
    body: `appId=${appId}`,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }).then(function(response) {
    return response.json();
  });
};

export {
  PWA2APK_PAYMENT_REDIRECT_URL,
  WEB2DESK_PAYMENT_REDIRECT_URL,
  createApp,
  getApp,
  updateApp,
  uploadFile,
  checkStatus,
  emailDeveloper,
  createDesktopApp,
  getDesktopAppStatus
};
